import React from 'react';
// editor
import { EditorState, AtomicBlockUtils, convertToRaw } from 'draft-js';
import { createEditorState, BLOCK_BUTTONS, Editor } from 'medium-draft';
import 'medium-draft/lib/index.css';
import './custom-medium-draft.css';
// material-ui
import IconImage from 'material-ui/svg-icons/image/image';
import IconVideo from 'material-ui/svg-icons/av/videocam';
// editor helpers
import { renderer } from '../AtomicBlock';
import EmbedSideButton from '../EmbedSideButton';
// media
import PopupGallery from '../../media/PopupGallery';
// добавление элементов галереи в редактор
import insertMediaItem, { insertGallery } from '../insertMediaItem';
// style
import { colors } from '../../../lib/styles';

const Typograf = require('typograf');

type Props = {
	state: ?Object,
	onChange: Function,
	location: ?Object,
	readOnly?: boolean,
};

type State = {
	editorState: Function,
	mediaGalleryType: Array<string>,
	openMediaGallery: boolean,
};

const blockButtons = [
	{
		label: 'H1',
		style: 'header-one',
		icon: 'header',
		description: 'Heading 1',
	},
	{
		label: 'H2',
		style: 'header-two',
		icon: 'header',
		description: 'Heading 2',
	},
].concat(BLOCK_BUTTONS);

const isRawState = state => state && typeof state.blocks !== "undefined" && typeof state.entityMap !== "undefined";

class DraftEditor extends React.Component<Props, State> {

	editorRef = React.createRef();

	constructor(props) {
		super(props);
		const state = props.state;
		const editorState = state instanceof EditorState
			? state
			: isRawState(state) ? createEditorState(props.state) : createEditorState();

		this.state = {
			editorState,
			mediaGalleryType: ['image'],
			openMediaGallery: false,
		};

		this.sideButtons = [
			{
				title: 'Медиа-галерея видео',
				component: this.galleryBtnVideo,
			},
			{
				title: 'Медиа-галерея изображения',
				component: this.galleryBtnImage,
			},
			{
				title: 'Эмбед',
				component: EmbedSideButton,
			},
		];
	}

	componentDidMount = () => {
		if(this.editorRef.current) {
			this.editorRef.current.focus();
		}
		const toolbar = document.getElementsByClassName('md-RichEditor-controls-inline')[0];
		const span = document.createElement('span');
		span.className = 'md-RichEditor-styleButton md-RichEditor-styleButton-typograf hint--top js-typograf';
		span.setAttribute('aria-label', 'Типограф');
		span.innerHTML = 'T';
		toolbar.insertBefore(span, toolbar.children[4]);
		document.getElementsByClassName('js-typograf')[0].addEventListener('click', event => {
			event.preventDefault();
			this.typograf();
		});
		if (this.props.location && this.props.location.insertItem) {
			// Переходим в конец материала
			let { editorState } = this.state;
			editorState = EditorState.moveFocusToEnd(editorState);
			this.setState({ editorState });
			// Добавляем пустую строку, в которую будем вставлять элемент
			const content = editorState.getCurrentContent();
			const contentWithEntity = content.createEntity('empty', '', {});
			const entityKey = contentWithEntity.getLastCreatedEntityKey();
			editorState = EditorState.push(editorState, contentWithEntity, 'create-entity');
			this.setState({
				editorState: AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, 'E'),
			});
			setTimeout(() => {
				this.insertMediaFile(this.props.location.insertItem);
			}, 250);
		}
	};

	onChange(editorState) {
		this.props.onChange(editorState);
		this.setState({ editorState });
	}

	/**
	 * Обновление информации о том, где начинаются ссылки и стили
	 * @param entity новая строка
	 * @param original оригинальная строка
	 * @returns {*}
	 */
	updateEntity = (entity, original) => {
		entity.entityRanges.forEach((item, index) => {
			const wrappedText = original.text.substr(item.offset, item.length);
			const newPosition = entity.text.indexOf(wrappedText);
			item.offset = newPosition;
		});
		entity.inlineStyleRanges.forEach((item, index) => {
			const wrappedText = original.text.substr(item.offset, item.length);
			const newPosition = entity.text.indexOf(wrappedText);
			item.offset = newPosition;
		});
		return entity;
	};

	typograf = () => {
		const { editorState } = this.state;
		const raw = convertToRaw(editorState.getCurrentContent());
		const original = convertToRaw(editorState.getCurrentContent());
		raw.blocks.forEach((item, index) => {
			const { text } = item;
			const modifier = findWithRegex(text);
			if (text !== 'E' && text) {
				item.text = modifier.text;
				if (modifier.flag) {
					raw.entityRanges = this.updateEntity(item, original.blocks[index]);
				}
			}
		});

		this.onChange(createEditorState(raw));
	};

	insertMediaFile = item => this.onChange(insertMediaItem(item, this.state.editorState));
	insertGallery = items => this.onChange(insertGallery(items, this.state.editorState));
	handleCloseGallery = () => this.setState({ openMediaGallery: false });

	galleryBtnImage = () => (
		<button
			className="medium-draft--btn"
			type="button"
			onClick={() => {
				this.setState({
					mediaGalleryType: ['image'],
					openMediaGallery: true,
				});
			}}
			title="Add an Image"
		>
			<IconImage color={colors.iconColor} hoverColor={colors.iconHover} />
		</button>
	);

	galleryBtnVideo = () => (
		<button
			className="medium-draft--btn"
			type="button"
			onClick={() => {
				this.setState({
					mediaGalleryType: ['video'],
					openMediaGallery: true,
				});
			}}
			title="Add an Video"
		>
			<IconVideo color={colors.iconColor} hoverColor={colors.iconHover} />
		</button>
	);

	render() {
		const { editorState } = this.state;
		return (
			<div>
				<PopupGallery
					open={this.state.openMediaGallery}
					type={this.state.mediaGalleryType}
					closeDialogHandle={() => {
						this.setState({ openMediaGallery: false });
					}}
					insertMediaFile={item => {
						this.insertMediaFile(item);
						setTimeout(() => {
							this.handleCloseGallery();
						}, 250);
					}}
					insertMultipleMediaFiles={items => {
						this.insertGallery(items);
						setTimeout(() => {
							this.handleCloseGallery();
						}, 250);
					}}
					insertAfterClick={false}
					orientation="vertical"
					insertAfterUpload={true}
				/>
				<Editor
					blockButtons={blockButtons}
					ref={this.editorRef}
					editorState={editorState}
					sideButtons={this.sideButtons}
					rendererFn={renderer}
					onChange={event => {
						this.onChange(event);
					}}
					editorEnabled={!this.props.readOnly}
				/>
			</div>
		);
	}
}

/**
 * Использование типографики
 * @param text
 * @returns {{text: string, flag: boolean}} флаг — изменилась ли длина строки.
 */
const findWithRegex = text => {
	const tp = new Typograf({ locale: ['ru'] });
	tp.enableRule('ru/punctuation/hellipQuestion');
	tp.enableRule('ru/other/accent');
	tp.enableRule('ru/nbsp/years');
	tp.enableRule('common/space/trimLeft');
	tp.enableRule('common/space/trimRight');
	tp.enableRule('common/space/delRepeatSpace');
	tp.enableRule('common/space/afterPunctuation');
	tp.enableRule('common/number/times');
	let result = tp.execute(text);
	result = result.replace('\u2013', '\u2014');
	result = result.replace('\u001F', '');
	result = result.replace('\u0003', '');
	return { text: result, flag: text.length !== result.length };
};

export default DraftEditor;



// WEBPACK FOOTER //
// src/components/editor/draft/DraftEditor.js